export function deletePassage(document, passageId) {
  if (!document?.passages?.some((passage) => passage.id === passageId)) return document;
  if (document.passages.length <= 1) throw new Error("A story must contain at least one passage.");
  return {
    ...document,
    passages: document.passages
      .filter((passage) => passage.id !== passageId)
      .map((passage) => ({
        ...passage,
        links: (passage.links || []).filter((link) => link.target !== passageId),
      })),
  };
}

export function makeStartingPassage(document, passageId) {
  const passage = document?.passages?.find((item) => item.id === passageId);
  if (!passage || document.passages[0]?.id === passageId) return document;
  return {
    ...document,
    passages: [passage, ...document.passages.filter((item) => item.id !== passageId)],
  };
}

export function duplicatePassage(document, passageId, id) {
  const passage = document?.passages?.find((item) => item.id === passageId);
  if (!passage) return { document, passage: null };
  const copy = {
    ...structuredClone(passage),
    id,
    title: `${passage.title} copy`,
    x: Number(passage.x || 0) + 42,
    y: Number(passage.y || 0) + 42,
  };
  return { document: { ...document, passages: [...document.passages, copy] }, passage: copy };
}
